import distinct from './distinct';
function notEqual(value1, value2) {
    return value1 !== value2;
}
export default function distinctUntilChanged(stream) {
    return distinct(notEqual, stream);
}
//# sourceMappingURL=distinct-until-changed.js.map